module.exports = __webpack_public_path__ + "544c7bba69421eb7b3e14798903e19c9.png";